<template>
  <s-field :id :label :description :error :required :tooltip>
    <template v-slot="a11yProps">
      <s-multi-select
        :options="options"
        :placeholder="placeholder"
        :max="max"
        v-model="model"
        @confirm:selection="emit('confirm:selection')"
        v-bind="{...$attrs, ...a11yProps}"
        @select:option="emit('select:option', $event)"
      >
        <template v-if="$slots.selected" #selected="{selected}">
          <slot name="selected" v-bind="{selected}"></slot>
        </template>
        <template v-if="$slots.option" #option="slotProps">
          <slot name="option" v-bind="slotProps"></slot>
        </template>
      </s-multi-select>
    </template>
  </s-field>
</template>
<script setup lang="ts" generic="T extends Option">
import SField from '../SField.vue';
import SMultiSelect from './SMultiSelect.vue';
import type {Option} from './Option';

const model = defineModel<Array<T['value']>>({default: []});

defineProps<{
  id: string;
  label?: string;
  description?: string;
  options: T[];
  placeholder?: string;
  tooltip?: string;
  error?: string | null;
  required?: boolean;
  max?: number;
}>();

const emit = defineEmits<{
  'confirm:selection': [];
  'select:option': [option: Option];
}>();
</script>
<script lang="ts">
export default {
  inheritAttrs: false,
};
</script>
